import { render, staticRenderFns } from "./AdminProductBestSeller.vue?vue&type=template&id=365b4fec"
import script from "./AdminProductBestSeller.vue?vue&type=script&lang=js"
export * from "./AdminProductBestSeller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports